import { useDispatch } from 'react-redux';
import history from '../history';
import {
  clearLocalStorage,
  getLocalStorage,
  removeLocalStorage,
} from '../utils';
import { AUTH_TOKEN, STATE } from '../data/local-storage-constants';
import {
  clearPollingData,
  logout,
  resetCreditReportData,
  resetLeads,
  resetLendersData,
} from '../redux/slices';
import { GST_ROUTE, HOME_PAGE_ROUTE } from '../data/routes-constants';
import {
  defaultUserCreditDetails,
  useCreditContext,
} from '../features/credit-report/component/credit-score-context';
import { isFlipkartFlow } from '../features/credit-report-apply/helper';

const useLogin = () => {
  const { setUserCreditDetails } = useCreditContext();
  const dispatch = useDispatch();

  const handleLogout = (checkIfTokenPresent = true) => {
    if (checkIfTokenPresent) {
      const token = getLocalStorage(AUTH_TOKEN);
      if (!token) {
        handleStateReset();
      }
      return;
    }
    handleStateReset();
  };

  const handleStateReset = () => {
    isFlipkartFlow() ? history.push(GST_ROUTE) : history.push(HOME_PAGE_ROUTE);
    removeLocalStorage(AUTH_TOKEN);
    removeLocalStorage(STATE);
    clearLocalStorage();
    dispatch(logout());
    setUserCreditDetails(defaultUserCreditDetails);
    dispatch(resetCreditReportData());
    dispatch(resetLeads());
    dispatch(resetLendersData());
    dispatch(clearPollingData());
  };

  return { handleLogout };
};

export default useLogin;
